import { useStore, createStore } from 'zustand';
import { persist } from 'zustand/middleware';

const initState = {
  websiteMessage: '',
};

export const messageStore = createStore(
  persist(
    (set) => ({
      ...initState,
      setMessage: async (message) => set(() => ({ websiteMessage: message })),
      resetMessage: async () => {
        set(initState);
      },
    }),
    {
      name: 'citylife_messages',
    },
  ),
);

export const useMessageStore = () => useStore(messageStore);
